module.exports = __webpack_public_path__ + "img/thumbnail_PrairieDog_j_normal.a104ce52.png";